import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { LogoutCooldownLimitConfigService } from "./logout-cooldown-limit.config";
import {
	LogoutCooldownLimitDelete,
	LogoutCooldownLimitState,
	LogoutCooldownLimitUpdate,
} from "./logout-cooldown-limit.model";

@Injectable({
	providedIn: "root",
})
export class LogoutCooldownLimitService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: LogoutCooldownLimitConfigService
	) {}

	get(): Observable<LogoutCooldownLimitState> {
		return this.httpClient.get<LogoutCooldownLimitState>({
			url: this.config.getLogoutCooldownEndpoint(),
		});
	}

	update(params: LogoutCooldownLimitUpdate): Observable<void> {
		return this.httpClient.put<void>({
			url: this.config.getLogoutCooldownEndpoint(),
			data: params,
		});
	}

	delete(params: LogoutCooldownLimitDelete): Observable<void> {
		return this.httpClient.delete<void>({
			url: this.config.getLogoutCooldownEndpoint(),
			data: params,
		});
	}
}
